import axios from './axios.config'

export default {
    async login(params) {
        return axios.post('/v1/admin/login', params)
    },
    async getUserInfo(params) {
        return axios.post('/v1/admin/getUserInfo', params)
    },
    async createUser(params) {
        return axios.post('/v1/user/create', params)
    },
    async userList(params) {
        return axios.post('/v1/user/list', params)
    },
    async userInfo(params) {
        return axios.post('/v1/user/info', params)
    },
    async getBlockList(params) {
        return axios.post('/v1/user/getBlockList', params)
    },
    async updateUserStatus(params) {
        return axios.post('/v1/user/updateUserStatus', params)
    },
    async getSensetive(params) {
        return axios.post('/v1/user/getSensetive', params)
    },
    async addSensetive(params) {
        return axios.post('/v1/user/addSensetive', params)
    },
    async delSensetive(params) {
        return axios.post('/v1/user/delSensetive', params)
    },
    async sensitiveShot(params) {
        return axios.post('/v1/user/sensitiveShot', params)
    },
    async sendMsg(params) {
        return axios.post('/v1/user/sendMsg', params)
    },
    async getIndexInfo(params) {
        return axios.post('/v1/admin/getIndexInfo', params)
    },
    async getUploadToken(params) {
        return axios.post('/v1/admin/getUploadToken', params)
    },
    async updateIcon(params) {
        return axios.post('/v1/admin/updateIcon', params)
    },
    async updatePhone(params) {
        return axios.post('/v1/admin/updatePhone', params)
    },
    async updatePwd(params) {
        return axios.post('/v1/admin/updatePwd', params)
    },
    async configs(params) {
        return axios.post('/v1/admin/configs', params)
    },
    async delSensitiveShot(params) {
        return axios.post('/v1/user/delSensitiveShot', params)
    },
    async delSensitiveShot(params) {
        return axios.post('/v1/user/delSensitiveShot', params)
    },
    async groupList(params) {
        return axios.post('/v1/group/list', params)
    },
    async groupCreate(params) {
        return axios.post('/v1/group/create', params)
    },
    async groupUsers(params) {
        return axios.post('/v1/group/users', params)
    },
    async groupAddUser(params) {
        return axios.post('/v1/group/addUser', params)
    },
    async groupDelUser(params) {
        return axios.post('/v1/group/delUser', params)
    },
    async transferGroup(params) {
        return axios.post('/v1/group/transferGroup', params)
    },
    async dismissGroup(params) {
        return axios.post('/v1/group/dismissGroup', params)
    },
    async messages(params) {
        return axios.post('/v1/message/list', params)
    },
    async recall(params) {
        return axios.post('/v1/message/recall', params)
    },
    async multicast(params) {
        return axios.post('/v1/message/multicast', params)
    },
    async broadcast(params) {
        return axios.post('/v1/message/broadcast', params)
    },
    async settinginfo(params) {
        return axios.post('/v1/settings/info', params)
    },
    async settingupdate(params) {
        return axios.post('/v1/settings/update', params)
    },
    async channelSave(params) {
        return axios.post('/v1/channel/save', params)
    },
    async channelList(params) {
        return axios.post('/v1/channel/list', params)
    },
    async robotSave(params) {
        return axios.post('/v1/robot/save', params)
    },
    async robotList(params) {
        return axios.post('/v1/robot/list', params)
    },
    async userAlls(params) {
        return axios.post('/v1/user/alls', params)
    },
    async changeUserType(params) {
        return axios.post('/v1/group/changeUserType', params)
    },
    async modifyGroupInfo(params) {
        return axios.post('/v1/group/modifyGroupInfo', params)
    }


}



// WEBPACK FOOTER //
// ./src/api.js